/**
 * Configuration Provider Component
 * Loads runtime configuration and provides loading UI
 */

import React from 'react';
import { Box, Spinner, Text, VStack } from '@chakra-ui/react';
import { useRuntimeConfig } from '../hooks/useRuntimeConfig';

interface ConfigProviderProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function ConfigProvider({ children, fallback }: ConfigProviderProps) {
  const { config, isLoading, error } = useRuntimeConfig();

  if (isLoading) {
    return (
      fallback || (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          bg="gray.50"
        >
          <VStack gap={4}>
            <Spinner size="lg" color="blue.500" strokeWidth="4px" />
            <VStack gap={1}>
              <Text fontSize="lg" fontWeight="medium" color="gray.700">
                Loading configuration...
              </Text>
              <Text fontSize="sm" color="gray.500">
                Loading Byte Pantry
              </Text>
            </VStack>
          </VStack>
        </Box>
      )
    );
  }

  if (error) {
    console.warn('Configuration error, continuing with fallback:', error);
    // Continue anyway - the API config will use fallback values
  }

  if (config) {
    console.log('✅ Configuration loaded successfully:', {
      environment: config.environment,
      apiUrl: config.apiUrl,
      mediaUrl: config.mediaUrl,
    });
  }

  return <>{children}</>;
}
